import React from "react";

const ArchiveMultiple = props => {
  return (
    <svg width="28" height="22" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#C7C7C7" d="M9 8h18v12a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V8z" />
        <path
          stroke="#DFE0DF"
          strokeLinecap="round"
          strokeWidth="2"
          d="M14.5 14h7"
        />
        <path fill="#C9C9C9" d="M8 7h20V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v1z" />
        <path fill="#ADADAD" d="M5 6h18v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6z" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeWidth="2"
          d="M10.5 12h7"
        />
        <path fill="#ADADAD" d="M4 5h20V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1z" />
        <path fill="#838383" d="M1 4h18v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4z" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeWidth="2"
          d="M6.5 10h7"
        />
        <path fill="#838383" d="M0 3h20V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v1z" />
      </g>
    </svg>
  );
};

export default ArchiveMultiple;
